import { apiClient } from "./client";
import { User } from "../interfaces";

export interface LoginPayload {
  usernameOrEmail: string;
  password?: string;
  twoFactorCode?: string;
  captchaToken: string;
}

export interface RegisterPayload {
  username: string;
  email: string;
  password?: string;
  language?: string;
  captchaToken: string;
}

export const authApi = {
  login: (data: any) => apiClient.post<User>("/auth/login", data),

  register: (data: any) => apiClient.post<void>("/auth/register", data),

  verifyEmail: (data: { token: string }) =>
    apiClient.post<User>("/auth/verify-email", data),

  forgotPassword: (data: { email: string; captchaToken: string }) =>
    apiClient.post<void>("/auth/forgot-password", data),

  resetPassword: (data: any) =>
    apiClient.post<void>("/auth/reset-password", data),

  getMe: () => apiClient.get<User>("/auth/me"),

  refresh: () => apiClient.post<User>("/auth/refresh", {}),

  logout: () => apiClient.post<void>("/auth/logout", {}),
};
